import { Link } from "react-router-dom";

export default function Loading() {
    return (
        <>

            <title>TravelToolkit – Travel App | Location, Translator, Near Me & More</title>
            <meta name="description" content="TravelToolkit is your all-in-one travel companion. Find nearby places, translate languages, check currency rates, discover food apps, and access emergency services anywhere in the world." />
            <meta name="keywords" content="travel app, near me places, translator app, currency converter, food delivery apps worldwide, emergency numbers by country, travel tools app, global travel assistant, location finder app" />

            <meta property="og:title" content="TravelToolkit – Travel App | Location, Translator, Near Me & More" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/" />
            <meta property="og:description" content="TravelToolkit is your all-in-one travel companion. Find nearby places, translate languages, check currency rates, discover food apps, and access emergency services anywhere in the world." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="TravelToolkit is your all-in-one travel companion. Find nearby places, translate languages, check currency rates, discover food apps, and access emergency services anywhere in the world." />
            <meta name="twitter:app:country" content="India" />

            <div className="vh-100 bgg d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <div className="mx-auto">
                        <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <img src="/images/earth.gif" className="img-fluid imgg" />
                        </div>
                        <h1 className="text-white fw-bold">🌐TravelToolkit</h1>
                        <p className="fst-italic text-light">Everything you need. Anywhere in the World.</p>
                        <Link to="/Dashboard" >
                            <button className="btn btn-gradient px-4 py-2 mb-4 shadow text-light">Get Started ➡️</button>
                        </Link>
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                            {["📍 Location", "🌐 Translator", "📡 Near Me", "🍔 Food Apps", "💱 Currency", "⚠️ Emergency"].map((row) => (
                                <div className="feature-pill">
                                    {row}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}